import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'SearchByName',
})
export class SearchFilesByCategoryPage implements PipeTransform {
  transform(value: any, input: string) {
    if (input) {
      return value.filter(function (el: any) {
        const FileCategory = el.fileName.toUpperCase().includes(input.toUpperCase());
        return FileCategory;
      });
    }
    return value;
  }
}
